import PaymentMethodsInput from '../../components/pages/payment_methods/payment-methods-input'
export default {
  components: { PaymentMethodsInput }
}
